export default {
  404: "404",
  register: "注册",
  login: "登录",
  profit: "利润",
  payout: "目标支付",
  btnDouble: "2×",
  wagered: "投注额",
  deposit: "存款",
  inputFieldBtnMax: "最大",
  bets: "投注",
  topHeaderAmount: "金额",
  resetPasswordTitle: "重置密码",
  resetPasswordNewPasswordTitle: "新密码",
  resetPasswordNewPasswordErrorsRequired: "密码为必填项。",
  resetPasswordNewPasswordErrorsMinLength: "最少允许 8 个字符。",
  resetPasswordNewPasswordErrorsMaxLength: "最多允许 16 个字符。",
  resetPasswordNewPasswordErrorsPattern:
    "必须是 8-16 个字符，包括大写和小写字母、数字及特殊字符（例如：NextGen@123）",
  resetPasswordConfirmPasswordTitle: "确认密码",
  resetPasswordConfirmPasswordErrorsNotMatched: "密码不匹配。",
  resetPasswordResetBtn: "重置",
  passwordResetSuccess: "密码已更改",
  resetPasswordWentWrong: "出了点问题！",
  partners: "合作伙伴",
  submit: "提交",
  signinUsername: "邮箱 / 用户名",
  signinForgetPassword: "忘记密码？",
  signinErrorsUserNameRequired: "请输入用户名/邮箱。",
  signinErrorsPasswordRequired: "密码为必填项。",
  signinErrorsPasswordMinLength: "最少允许 8 个字符。",
  signinErrorsPasswordMaxLength: "最多允许 16 个字符。",
  signinTryAgain: "出了点问题！请重试。",
  signinResetPasswordUsernameErr: "请输入用户名/邮箱以重置密码。",
  signinResetMailSentSuccessContent:
    "我们已向您的邮箱发送了重置密码链接，请检查邮箱并重置密码。",
  signupTitle: "注册",
  signupUsername: "用户名",
  signupEmail: "邮箱",
  signupWalletConnect: "使用钱包登录",
  signupPassword: "密码",
  signupErrorsUserNameRequired: "请输入用户名。",
  signupErrorsFirstNameRequired: "请输入名字。",
  signupErrorsLastNameRequired: "请输入姓氏。",
  signupErrorsUserNameMinLength: "最少允许 {{minimumCharacters}} 个字符。",
  signupErrorsUserNameMaxLength: "最多允许 {{maximumCharacters}} 个字符。",
  signupErrorsUserNamePattern: "请输入字母和数字。",
  signupErrorsStringPattern: "请输入字母。",
  signupErrorsEmailRequired: "请输入邮箱。",
  signupErrorsEmailPattern: "请输入有效邮箱。",
  signupErrorsPasswordRequired: "密码为必填项。",
  signupErrorsPasswordMinLength: "最少允许 8 个字符。",
  signupErrorsPasswordMaxLength: "最多允许 16 个字符。",
  signupErrorsPasswordPattern:
    "必须是 8-16 个字符，包括大写和小写字母、数字及特殊字符（例如：NextGen@123）",
  otpIsRequired: "验证码为必填项",
  otpMustBeSixDigits: "验证码必须为 6 位数字",
  enterOtp: "输入验证码",
  accountMenuTransactions: "交易记录",
  accountMenuPromotions: "优惠活动",
  accountMenuProfile: "个人资料",
  accountMenuLogout: "退出登录",
  accountMenuWithdraw: "提现",
  pageNotFound: "我们无法找到您要访问的页面！",
  error: "错误",
  somethingWentWrong: "出了点问题！",
  verifyEmailThankYou: "谢谢！",
  verifyEmailEmailIsVerified: "您的邮箱已验证。",
  verifyEmailWentWrong: "出了点问题！",
  verifyEmailTokenExpired: "邮箱已验证或链接已过期",
  create: "创建",
  profilePassword: "密码",
  profileUploadProfile: "上传头像",
  profileErrorsEmailRequired: "邮箱为必填项。",
  profileErrorsEmailPattern: "请输入有效邮箱。",
  profileErrorsEmailMinLength: "最少允许 3 个字符。",
  profileErrorsEmailMaxLength: "最多允许 20 个字符。",
  profileMessagesProfileUpdate: "资料已更新",
  profileMessagesChangePassword: "密码已更新",
  profileProfilePicProfilePicUpload: "上传头像",
  profileNoNewChanges: "无法更新资料！没有新更改。",
  profileLoggedInWithSocial: "您已使用社交登录登录。",
  profileSideNavigatorSound: "声音",
  profileSideNavigatorMusic: "音乐",
  profileSideNavigatorProfile: "我的资料",
  profileSideNavigatorBetHistory: "投注历史",
  profileSideNavigatorTransactions: "交易记录",
  profileSideNavigatorDeposit: "存款",
  withdraw: "提现",
  profileSideNavigatorGameLimits: "游戏限制",
  profileSideNavigatorReferral: "推荐",
  profileSideNavigatorChangePassword: "修改密码",
  profileSideNavigatorTermsConditions: "条款与条件",
  profileSideNavigatorLogOut: "退出登录",
  profileSideNavigatorProvablyFair: "可验证公平",
  WalletInfoSectionNotAvailable: "不可用",
  WalletInfoSectionRealBalance: "真实余额",
  GameLimitsMinimumBet: "最低投注",
  GameLimitsMaximumBet: "最高投注",
  GameLimitsMaxWinFor1Bet: "单注最高奖金",
  ProvablyFairSubTitle:
    "此游戏使用可验证公平技术来确定游戏结果。此工具允许您更改种子并检查游戏的公平性。",
  ProvablyFairMaximumBet: "最高投注：",
  ProvablyFairMaxWinFor1Bet: "单注最高奖金",
  promotionsTitle: "优惠活动",
  promotionsNoLosingData: "抱歉，暂无可用的亏损奖励活动",
  promotionsNoDepositData: "抱歉，暂无可用的存款奖励活动",
  promotionsCurrency: " 货币。",
  promotionsViewBtn: "查看",
  promotionsClaimSuccess: "您已成功领取",
  promotionsAvailability: "可用性：",
  promotionsAvailabilityTabLosing: "亏损奖励",
  promotionsAvailabilityTabDeposit: "存款奖励",
  promotionsDepositBonusTableCode: "代码",
  promotionsDepositBonusTableMinDeposit: "最小存款",
  promotionsDepositBonusTablePercentage: "百分比",
  promotionsDepositBonusTableMaxBonus: "最高奖励",
  promotionsDepositBonusTableRolloverMultipler: "流水倍数",
  promotionsDepositBonusTableMaxRolloverPerBet: "单注最高流水",
  promotionsDepositBonusTableTimeToAchieveRolloverTarget:
    "完成流水目标所需时间",
  promotionsBonusCode: "奖励代码：",
  promotionsLossesClaim: "可在活动期间领取亏损：",
  promotionsLossesClaimLosingBonusTablePercentage: "百分比",
  promotionsLossesClaimLosingBonusTableMinLosingAmount: "最小亏损金额",
  promotionsBonusStatus: "奖励状态：",
  promotionsBonusAmount: "奖励金额：",
  promotionsRolloverTarget: "流水目标：",
  promotionsRolloverAchieved: "已完成流水：",
  promotionsActivatebtn: "激活",
  promotionsClaimBtn: "领取",
  promotionsCancelBtn: "取消",
  promotionsBackBtn: "返回",
  promotionsBonus: "奖励",
  promotionsTermAndConditions: " 条款与条件",
  promotionsClaimDepositBonusTitle: "领取存款奖励步骤",
  promotionsClaimDepositBonusFirst: "激活奖励代码",
  promotionsClaimDepositBonusSecond: "向钱包存款",
  promotionsClaimDepositBonusThird: "完成流水目标以领取奖励",
  promotionsClaimLosingBonusTitle: "领取亏损奖励步骤",
  promotionsClaimLosingBonusFirst: "激活奖励代码",
  promotionsClaimLosingBonusSecond: "玩您喜欢的游戏",
  promotionsClaimLosingBonusThird: "点击“领取亏损”在活动期间领取亏损",
  promotionsWentWrong: "出了点问题！",
  transactionTitle: "交易记录",
  transactionBetId: "投注ID",
  transactionUser: "用户",
  transactionPayout: "支付",
  transactionAmount: "金额",
  transactionTime: "日期",
  transactionProfit: "利润",
  transactionCashout: "兑现",
  transactionBet: "投注",
  transactionMultix: "倍数",
  transactionWin: "赢",
  transactionFairness: "公平性",
  transactionReferFriend: "推荐好友",
  transactionTotal: "总投注",
  transactionWins: "中奖",
  transactionRefresh: "刷新",
  transactionFilterTopMultipliers: "最高倍数",
  transactionFilterHugeWins: "巨额奖金",
  transactionFilterBiggestWins: "最大奖金",
  transactionFilterMultipliers: "倍数",
  transactionRealBalance: "真实余额",
  depositWithdrawTXDate: "日期",
  depositWithdrawTXAmount: "金额",
  depositWithdrawTXTxId: "交易ID",
  depositWithdrawTXTxType: "交易类型",
  depositWithdrawTXStatus: "状态",
  depositWithdrawTXNoData: "暂无数据。",
  depositTitle: "存款",
  depositHistory: "历史记录",
  depositSubTitle: "用户无法存取法币。请联系管理员进行法币交易。",
  depositCopyNotSupported:
    "您的浏览器不支持自动复制到剪贴板。\n请手动复制代码。",
  depositCopied: "地址已复制。",
  withdrawNoBalance: "余额不足。",
  withdrawMinAmount: "请输入大于或等于 {{min}} 的金额。",
  paginationNextBtn: "下一页",
  paginationPrevBtn: "上一页",
  LoginRequired: "需要登录！",
  betPlacedSuccessfully: "投注成功",
  betCancelledSuccessfully: "投注取消成功",
  PlayerEscapedSuccessfully: "玩家已退出",
  CopiedSuccessfull: "复制成功",
  usersConsent: "访问本网站即表示我已年满18岁，并已阅读、理解并同意",
  termsOfService: "服务条款",
  email: "邮箱",
  playNow: "立即游戏",
  orContinueWith: "或使用以下方式继续",
  metamaskExtensionNotAvailable: "请安装 MetaMask 插件并刷新页面。",
  cashier: "存款",
  account: "账户",
  hello: "您好",
  balance: "余额",
  referrals: "推荐",
  settings: "设置",
  withdrawals: "提现",
  demoWallet: "演示钱包",
  wallet: "钱包",
  user: "用户",
  amountIsRequired: "金额为必填项",
  minDepositAmount: "存款金额必须大于 {{min}}。",
  maxDepositAmount: "存款金额必须小于 {{max}}。",
  minWithdrawAmount: "必须大于 {{min}}",
  withdrawMustLessThanWallet: "提现金额必须小于您的钱包余额",
  accountTypeIsRequired: "账户类型为必填项。",
  mobileNumberLength: "手机号必须为 {{length}} 位数字",
  phoneIsRequired: "手机号为必填项",
  cpfError: "CPF 必须为 {{length}} 位",
  cpfRequiredError: "CPF 为必填项",
  cnpjError: "CNPJ 必须为 {{length}} 位",
  mainMenu: "主菜单",
  casino: "赌场",
  sports: "体育",
  crypto: "加密货币",
  NextGenXp: "NextGen 经验值",
  playEarn: "玩 & 赚",
  NFT: "NFT",
  poker: "扑克",
  earnRewards: "获取奖励",
  rankUp: "升级",
  inviteFriends: "邀请好友",
  affiliates: "联盟",
  sportsbook: "体育投注",
  menu: "菜单",
  allBets: "所有投注",
  highRollers: "高额玩家",
  luckyBets: "幸运投注",
  trade: "交易",
  player: "玩家",
  time: "时间",
  wager: "投注额",
  payoutText: "支付",
  bannerHeadOne: "体验真正的创新，享受行业内最高",
  bannerHeadTwo: "奖励计划。",
  registerNow: "立即注册",
  copy: "复制",
  liveWins: "实时获胜",
  monthlyStatus: "月",
  weeklyStatus: "周",
  dailyStatus: "日",
  nextEcosystem: "NextGen 生态系统",
  allGames: "所有游戏",
  allSports: "所有体育",
  cryptoFutures: "加密期货",
  tradeNow: "立即交易",
  allTables: "所有桌面",
  nft: "NFT",
  viewAll: "查看全部",
  rewards: "奖励",
  profile: "个人资料",
  nextgenProfile: "NextGen 个人资料",
  totalBets: "总投注",
  totalWagered: "总投注额",
  joinDate: "加入日期",
  displaySocialLinks: "显示已绑定的社交账户",
  privateProfile: "私人资料",
  rank: "等级",
  nextRank: "下一级",
  changeUsername: "修改用户名",
  newPassword: "新密码",
  repeatNewPassword: "重复新密码",
  changeName: "修改姓名",
  linkSocialAccount: "绑定社交账户",
  privateProfileTooltip:
    "一旦将资料设为私人，其他用户将无法查看您的投注活动、奖励或社交链接",
  socialLinksTooltip: "绑定您的社交账户，允许其他用户关注您。",
  balances: "余额",
  createReferralBalance: "创建推荐余额",
  total: "总计",
  tips: "小费",
  receivedAmount: "已收金额",
  dateOrTime: "日期/时间",
  view: "查看",
  allChains: "所有链",
  creditAmount: "信用金额",
  setCustomReferralLink: "设置自定义推荐链接",
  changeEmail: "修改邮箱",
  newEmail: "新邮箱",
  newUsername: "新用户名",
  username: "用户名",
  changePassword: "修改密码",
  twoFactorAuthentication: "双因素认证",
  twoFactorAuthenticationTitle:
    "强烈建议使用双因素认证，它可以同时通过密码和手机保护您的账户。必须设置邮箱和密码以激活 2FA。启用 2FA 后，您将无法通过 Steam 登录。",
  enable2fa: "启用 2FA",
  verifyIdentityByKyc: "验证身份（KYC）",
  oldPassword: "旧密码",
  live: "直播",
  soccer: "足球",
  tennis: "网球",
  fifa: "FIFA",
  basketball: "篮球",
  iceHockey: "冰球",
  volleyball: "排球",
  tableTennis: "乒乓球",
  baseball: "棒球",
  golf: "高尔夫",
  boxing: "拳击",
  myBets: "我的投注",
  favourites: "收藏",
  americanFootball: "美式橄榄球",
  buyCrypto: "购买加密货币",
  oldEmail: "旧邮箱",
  loggedInSuccess: "登录成功",
  loggedOutSuccess: "登出成功",
  signup: "注册成功",
  tokenVerify: "验证码已发送到您的邮箱，请进行验证",
  emailVerify: "邮箱已验证",
  emailChangedSuccess: "邮箱已更新",
  emailUpdateOtp: "验证码已发送到新邮箱",
  profileUpdatedSuccess: "资料已更新",
  otpVerified: "一次性密码（OTP）已验证",
  twoFADeactivated: "双因素认证已禁用",
  internalServerError: "服务器内部错误",
  unAuthorized: "未授权",
  dataNotFound: "未找到数据",
  setReferralLink: "设置推荐链接...",
  notFound: "未找到",
  nextgenOriginals: "NextGen 原创",
  status: "状态",
  success: "成功",
  failed: "失败",
  pending: "待处理",
  date: "日期",
  to: "至",
  roundId: "回合ID",
  bet: "投注",
  win: "赢",
  at: "于",
  downloadAll: "全部下载",
  gameText: "游戏",
  searchGames: "搜索游戏",
  provider: "供应商",
  search: "搜索",
  all: "全部",
  sortBy: "排序方式",
  popular: "热门",
  loadMore: "加载更多",
  bitcoin: "比特币",
  btc: "BTC",
  chat: "聊天",
  loginToChat: "登录以聊天",
  send: "发送",
  expand: "展开",
  collapse: "收起",
  emailPlaceholder: "youremail@domain.com",
  removeFromFavourite: "从收藏中移除",
  addToFavourite: "添加到收藏",
  verify: "验证",
  accountVerification: "账户验证",
  recentlyPlayed: "最近游戏",
  moreFrom: "更多来自",
  demoMode: "演示模式",
  providersList: "供应商列表",
  games: "游戏",
  providers: "供应商",
  close: "关闭",
  joinedOn: "加入日期",
  rewarded: "已奖励",
  saySomething: "说点什么",
  addressIsRequired: "地址为必填项",
  withdrawRequestSent: "提现请求已提交，等待审批。",
  noMatchesFound: "未找到匹配项",
  tip: "小费",
  sendTip: "发送小费",
  minAmount: "金额必须大于 {{min}}",
  maxAmount: "金额必须小于 {{max}}",
  doNotShowTip: "聊天中不显示小费",
  demoAvailable: "提供演示",
  denoNotAvailable: "演示不可用",
  goFullscreen: "全屏显示",
  endsAt: "结束时间",
  inProgress: "进行中",
  eventEnd: "活动结束",
  latestPromotions: "最新优惠",
  archived: "已归档",
  noPromotionsFound: "未找到优惠",
  claim: "领取",
  add: "添加",
  viewDashboard: "查看仪表盘",
  prize: "奖品",
  timeLeft: "剩余时间",
  viewTransactions: "查看交易记录",
  sendAmountInCashier:
    "将您选择的 {{- currency}} 金额发送到以下地址以获取等值币种。",
  yourPersonalDepositAddress: "您的个人 {{- currency}} 存款地址",
  copyAddress: "复制地址",
  theValueOfCurrencyMayChange:
    "从现在到我们收到您的付款时，{{- currency}} 的价值可能会变化",
  doNotHaveAnyCurrency: "没有任何 {{- currency}}？",
  depositOptions: "存款选项",
  withdrawalOptions: "提现选项",
  withdrawCurrency: "提现 {{- currency}}",
  enterAddressToReceiveFunds:
    "请输入您希望接收资金的 {{- currency}} 钱包地址。确认后，提现通常在几分钟内处理完成。",
  receivingCurrencyAddress: "接收 {{- currency}} 地址",
  withdrawalAmount: "提现金额",
  pasteYourCurrencyAddressHere: "在此粘贴您的 {{- currency}} 钱包地址...",
  request: "请求",
  receiveTheSpecifiedAmount:
    "*您将收到指定数量的 {{- currency}} 到您的提现地址",
  valueMayVary: "*从您的余额中扣除的数额可能会在我们处理提现时有所不同",
  coupons: "优惠券",
  updateEmail: "更新邮箱",
  update: "更新",
  loginHistory: "登录历史",
  showLoginHistory: "显示登录历史",
  wagerErr: "投注金额为必填项",
  minWagerErr: "最小投注金额为 1",
  mulValErr: "倍数值必须在 1 - 1000 之间",
  closeBetErr: "请输入有效的平仓金额",
  profitErr: "请输入有效的止盈金额",
  multiplierErr: "倍数金额为必填项",
  manual: "手动",
  auto: "自动",
  pnLFee: "盈亏手续费",
  flatFee: "固定手续费",
  takeProfitLabel: "止盈价格",
  closeBetLabel: "平仓价格",
  priceUpLabel: "价格会涨还是会跌？",
  up: "涨",
  down: "跌",
  payoutMul: "支付倍数",
  safe: "安全",
  wild: "激进",
  placeBet: "下单",
  roundEnd: "回合结束倒计时",
  timerInfo: "所有过山车投注将在每天00:00 UTC关闭，价格将重置为 $1,000",
  month: "月",
  PNL: "盈亏",
  ROI: "投资回报率",
  roi: "投资回报率",
  funding: "资金/H",
  exitPriceLabel: "退出价格",
  cashedOut: "已兑现",
  open: "进行中",
  chartPreferences: "图表偏好",
  yAxis: "Y轴偏好",
  additionalFeatures: "附加功能",
  themes: "主题",
  locale: "地区设置",
  changeTimezone: "更改时区",
  changeLanguage: "更改语言",
  tooltip: "提示",
  field: "字段",
  value: "数值",
  dateTime: "日期/时间",
  winningAmount: "获胜金额",
  activeBets: "活跃投注",
  closedBets: "已关闭投注",
  publicBets: "公开投注",
  leaderboard: "排行榜",
  howToPlay: "怎么玩",
  rOICalculator: "ROI计算器",
  allInstruments: "所有工具",
  week: "周",
  monthLabel: "月",
  day: "日",
  betLabel: "投注",
  entryPrice: "入场价格",
  bustPriceLabel: "爆仓价格",
  multiplierLabel: "倍数",
  exitPrice: "退出价格",
  pnl: "盈亏",
  details: "查看详情",
  profitLoss: "盈亏",
  noBalance: "余额不足",
  maxBetAmount: "最大投注额",
  limit: "超出限制",
  minBetAmount: "最小投注额",
  rollsLimitMsg: "翻滚次数必须小于或等于100。",
  mines: "地雷",
  loginFailed: "登录失败",
  noEntries: "无条目",
  descriptionIsRequired: "描述为必填项",
  description: "描述",
  report: "举报",
  userReportedSuccessfully: "用户已举报",
  tipSendSuccessfully: "小费已发送",
  walletSettings: "钱包设置",
  hideZero: "隐藏零余额",
  hideZeroInfo: "您的零余额不会显示在钱包中",
  displayFiat: "以法币显示加密货币",
  displayFiatInfo: "所有投注和交易将以加密货币等值结算",
  noteForApprox: "请注意，这些为货币近似值。",
  save: "保存",
  limits: "限制",
  wagerLimit: "投注限制",
  lossLimit: "亏损限制",
  depositLimit: "存款限制",
  takeABreak: "休息一下",
  customTimePeriod: "自定义时间段",
  timePeriod: "时间段",
  selfExclusion: "自我排除",
  confirm: "确认",
  setLimit: "设置限制",
  removeLimit: "移除限制",
  enterAmount: "输入金额",
  hours: "小时",
  daily: "每日",
  weekly: "每周",
  monthly: "每月",
  cancel: "取消",
  usedLimit: "已使用限制",
  type: "类型",
  updatedAt: "更新时间",
  editLimit: "编辑限制",
  limitRemovedMessage: "以下限制将被移除。",
  setLimitMessage:
    "您即将为账户设置以下限制。请注意，如果您想更改限制，可以在24小时后进行更改。",
  setBreakMessage:
    "您即将为账户设置预设时间段的访问封锁。一旦使用该选项，您将无法登录账户更改封锁时间。如需更改封锁时间或延长现有时间，请通过在线客服联系我们。",
  setSessionLimitMessage:
    "您即将为账户设置以下限制。请注意，如果您想更改限制，设置新的限制后需24小时生效。",
  removeSessionLimitMessage: "您的会话限制将被移除",
  notAchieved: "未达成",
  flexibleRegistration: "灵活注册！",
  mostPlayed: "最多玩法",
  badge: "徽章",
  allBadges: "所有徽章",
  socialMedia: "社交媒体",
  allLinks: "所有链接",
  statistics: "统计",
  newMessage: "新消息",
  tipFor: "小费给",
  play: "玩",
  betOn: "投注",
  liveCasino: "真人娱乐场",
  ecosystemUnbeatableOdds: "更佳投注 - 通过顶级投注平台获取精彩赛事无敌赔率！",
  startBetting: "开始投注",
  ecosystemJoinTheFun: "加入乐趣 - 探索NextGen独家游戏及9000+娱乐场热门游戏！",
  futures: "期货",
  ecosystemTrade: "NGB 是您可信赖的沉浸式在线游戏与投注平台通道！",
  ecosystemCasino24x7: "随时随地体验专业荷官实时游戏的刺激，尽享不停的动作！",
  joinNow: "立即加入",
  noNotificationsFound: "未找到通知",
  notifications: "通知",
  lobby: "大厅",
  rollercoaster: "NextGen 过山车",
  applyReferralCode: "使用推荐码",
  referralCode: "推荐码",
  referralLink: "推荐链接",
  copyLink: "复制链接",
  referralLinkCopied: "推荐链接已复制",
  withdrawAddressCannotBeSame: "提现地址不能与您的地址相同",
  userId: "用户ID",
  active: "活跃",
  inactive: "不活跃",
  currency: "货币",
  hostGames: "主持游戏，",
  earnCrypto: "赚取加密货币",
  inviteHostAndEarn: "邀请、主持 & 赚取 - 举办您的NextGen活动",
  startEarning: "开始赚钱",
  nextGen: "NextGen",
  whitePaper: "白皮书",
  deepDiveInto: "深入了解NextGen币经济",
  learnMore: "了解更多",
  sport: "体育",
  vipRanked: "VIP等级",
  betMoreEarnMore: "多投注，多收益 - 最大化您的潜力",
  expiresAt: "到期时间",
  upload: "上传",
  pleaseSelectImage: "请选择图片",
  imageSizeMustLessThan: "图片大小必须小于 {{size}} MB",
  imageSizeFormat: "请使用 png、jpeg、jpg 格式。",
  maxFileSize: "最大文件大小：2 MB",
  dragPosition: "拖动以更改位置",
  onlyNumbers: "仅限数字",
  cannotBeRemoved: "无法移除",
  amountInBetween: "金额应在每日与每月之间（含）",
  amountEqualOrGreater: "金额应大于或等于每周",
  amountEqualOrLess: "金额应小于或等于每周和每月",
  cannotBeIncreased: "无法增加",
  enterPassword: "输入密码",
  sessionLimit: "会话限制",
  timePeriodRequired: "时间段为必填项",
  amountGTZero: "金额必须大于零",
  mma: "综合格斗",
  counterStrike: "反恐精英",
  rugbyUnion: "橄榄球联盟",
  valorant: "无畏契约",
  cricket: "板球",
  dota: "DOTA-2",
  rugbyLeague: "橄榄球联盟",
  hilo: "Hilo",
  crash: "Crash",
  cancelBetSuccessfully: "投注已取消",
  start: "开始",
  invalidBetAmount: "投注金额无效",
  zeroError: "必须大于0",
  flipCoin: "抛硬币",
  customs: "自定义",
  redeemCode: "兑换优惠码",
  couponText: "我们会定期在我们的",
  copyrightText:
    "<aLink>{{website}}</aLink> 由 {{companyName}} 拥有和运营。注册号：{{registrationNumber}}，注册地址：{{address}}。请通过 <aMailto>{{email}}</aMailto> 联系我们。<aLink>{{website}}</aLink> 由科摩罗安儒昂自治岛政府许可和监管，许可证号：{{licenseNumber}}。<aLink>{{website}}</aLink> 已通过所有监管合规，可合法运营所有博彩和投注游戏。",
  platform: "平台",
  support: "支持",
  faq: "常见问题",
  partnershipProgram: "合作计划",
  blog: "博客",
  helpCenter: "帮助中心",
  aboutUs: "关于我们",
  community: "社区",
  facebook: "Facebook",
  twitter: "Twitter",
  instagram: "Instagram",
  discord: "Discord",
  english: "英语",
  hindi: "印地语",
  french: "法语",
  legal: "法律",
  cryptoTransactions: "加密货币交易",
  sendersName: "发送者姓名",
  hideLoginHistory: "隐藏登录历史",
  loginMethod: "登录方式",
  deviceType: "设备类型",
  ip: "IP地址",
  tradingDefinition:
    "加密货币交易按定义不属于赌博，因此不受我们的博彩许可证覆盖。",
  perks: "特权",
  connected: "连接已建立",
  twitch: "Twitch",
  connect: "连接",
  setUpGoogleAuthenticator: "设置谷歌验证器",
  twoFACode: "2FA代码",
  downloadTheGoogleAuthenticator:
    "1. 下载适用于iPhone或Android的Google Authenticator应用",
  saveTheFollowingAccountToken: "2. 将以下账户令牌（Key）安全保存",
  accountTokenKey: "账户令牌（Key）",
  scanQRCodeWithApp: "3. 使用Google Authenticator应用扫描二维码",
  enterTheTokenBelow: "4. 在下方输入令牌",
  copied: "已复制",
  code: "代码",
  furtherVerificationRequired: "需要进一步验证",
  firstName: "名",
  lastName: "姓",
  dateOfBirth: "出生日期",
  year: "年",
  addressLine: "地址行",
  addressLineTwo: "地址行2",
  city: "城市",
  province: "省/州",
  postalCode: "邮政编码",
  country: "国家",
  submitInformation: "提交信息",
  level: "等级",
  required: "必填",
  rejected: "已拒绝",
  completed: "已完成",
  cancelled: "已取消",
  onHold: "等待处理",
  kycRequestSubmittedSuccessfully: "KYC请求已提交",
  reRequested: "已重新请求",
  cashBalance: "现金余额",
  bonusBalance: "奖金余额",
  specialBonus: "特别奖金",
  today: "今天",
  noRewards: "暂无奖励",
  viewPendingRewards: "查看待领取奖励",
  totalClaimed: "累计领取",
  pendingRewards: "待领取奖励",
  amount: "金额",
  others: "其他",
  createdAt: "创建于",
  horseRacing: "赛马",
  addToHomeScreen: "将NextGen添加到主屏幕",
  oneTabAccess: "一键访问",
  install: "安装",
  addToHome: "添加到主屏幕",
  inChromeSafari: "在Chrome/Safari中，点击",
  buttonAndChoose: "按钮并选择",
  afterCompletingThisStep: "完成此步骤后，可在手机上一键访问NextGen投注！",
  settlementId: "结算ID",
  commission: "佣金",
  totalCommission: "总佣金",
  commissionSettlement: "佣金结算",
  startplaying: "开始游戏",
  forgotPassword: "忘记密码",
  resetPassword: "重置密码",
  locked: "已锁定",
  unlocked: "已解锁",
  yourRank: "您的等级",
  nextRanks: "下一级等级",
  allRanks: "所有等级",
  bonusClaimedSuccessfully: "奖励已领取",
  passwordUpdated: "密码已更新！",
  thatsOkayItHappens: "没关系，这种情况会发生。点击下方按钮继续。邮箱",
  passwordsMustMatch: "密码必须匹配",
  youNearlyThere: "您快完成了！",
  weSendYouVerificationEmail: "我们已发送验证邮件，请检查邮箱并验证账户。",
  verifyEmailAddress: "验证邮箱地址",
  pleaseNoteThatTheLinkWillExpire:
    "请注意，该链接将在5天后过期。如果您未注册NextGen Bets，请忽略此邮件。谢谢",
  autoBetStops: "自动投注因超出投注限制而停止",
  casinoBets: "赌场投注",
  sportsBet: "体育投注",
  cryptoTrades: "加密货币交易",
  customBets: "自定义投注",
  nothingFound: "未找到内容",
  bonus: "奖励",
  claimedAt: "领取于",
  available: "可用",
  previous: "上一个",
  next: "下一个",
  tooManyRequests: "请求过多",
  limitUpdatedSuccessFully: "限制已更新",
  youLost: "您输了",
  cashOutFailed: "提现失败",
  betAlreadyPlaced: "投注已存在",
  betCashedOut: "投注已兑现",
  noFavouritesIn: "暂无收藏",
  team: "NextGen团队",
  fiatAmount: "法币金额",
  cryptoAmount: "加密货币金额",
  moonpay: "Moonpay",
  paymentMethod: "支付方式",
  transactionId: "交易ID",
  address: "地址",
  comingSoon: "即将推出！",
  minOneCharacterRequired: "至少需要一个字符",
  verifyOtp: "验证OTP",
  noResults: "无结果",
  moreFromBrand: "更多来自NextGen Bets",
  cryptoDeposit: "加密货币充值",
  cryptoWithdraw: "加密货币提现",
  fiatDeposit: "法币充值",
  fiatWithdraw: "法币提现",
  goToPaymentsPage: "前往支付页面",
  bankTransfer: "银行转账",
  initiateTransfer: "发起转账",
  emt: "EMT",
  initiateEmt: "发起EMT",
  checkYourMailForFurtherDetails: "请检查邮箱获取详细信息",
  gigadet: "Gigadet",
  wallet88: "Wallet88",
  select_language: "选择语言",
  raise_a_ticket: "提交工单",
  view_website: "查看网站",
  back_home: "返回首页",
};
